module.exports = __webpack_public_path__ + "static/media/success.32976d79.svg";